import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import type { DirectionFindInterface } from '@zaoblako/shared/modules/catalog/dtos/direction/direction-find.dto';
import type { ClientFindInterface } from '@zaoblako/shared/modules/client/dtos/client/client-find.dto';
import { SubprojectDefaultsFormDto, type SubprojectDefaultsFormInterface } from '@zaoblako/shared/modules/project/dto/subproject-defaults/subproject-defaults-form.dto';
import type { UserGroupFindInterface } from '@zaoblako/shared/modules/security/dtos/user-group/user-group-find.dto';
import { GoBackButtonComponent } from '@zaoblako/web/shared/components/go-back-button/go-back-button.component';
import { BaseFormComponent } from '@zaoblako/web/shared/dumbs/base-form/base-form.component';
import { DealMultiSelectComponent } from '@zaoblako/web/shared/dumbs/dropdowns/deal-multi-select/deal-multi-select.component';
import { DirectionSingleSelectComponent } from '@zaoblako/web/shared/dumbs/dropdowns/direction-single-select/direction-single-select.component';
import { MasterMilestoneSingleSelectComponent } from '@zaoblako/web/shared/dumbs/dropdowns/master-milestone-single-select/master-milestone-single-select.component';
import { MultiSelectComponent } from '@zaoblako/web/shared/dumbs/dropdowns/multi-select/multi-select.component';
import { SingleSelectComponent } from '@zaoblako/web/shared/dumbs/dropdowns/single-select/single-select.component';
import { UnitSingleSelectComponent } from '@zaoblako/web/shared/dumbs/dropdowns/unit-single-select/unit-single-select.component';
import { UserMultiSelectComponent } from '@zaoblako/web/shared/dumbs/dropdowns/user-multi-select/user-multi-select.component';
import { JoinPipe } from '@zaoblako/web/shared/pipes/join.pipe';
import { ButtonModule } from 'primeng/button';
import { CardModule } from 'primeng/card';

@Component({
  standalone: true,
  selector: 'crm-subproject-defaults-form',
  templateUrl: './subproject-defaults-form.component.html',
  imports: [
    CommonModule,
    CardModule,
    ButtonModule,
    JoinPipe,
    SingleSelectComponent,
    MultiSelectComponent,
    FormsModule,
    GoBackButtonComponent,
    DealMultiSelectComponent,
    DirectionSingleSelectComponent,
    UnitSingleSelectComponent,
    MasterMilestoneSingleSelectComponent,
    UserMultiSelectComponent
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SubprojectDefaultsFormComponent extends BaseFormComponent<SubprojectDefaultsFormInterface> {
  public engine: 'class-transformer' | 'serde' = 'serde';

  @Input() public subprojectDefaults = <SubprojectDefaultsFormInterface>{};
  public dto = SubprojectDefaultsFormDto;

  @Input() public directions: DirectionFindInterface[];
  @Input() public clients: ClientFindInterface[];
  @Input() public userGroups: UserGroupFindInterface[];
  @Input() public withCard = false;

  @Input() public disabled = false;

  @Output() public changeDefaults = new EventEmitter<any>();
}
